// extracted by mini-css-extract-plugin
module.exports = {"customPagingButton":"NewsAnnouncements_customPagingButton__1twIM","prevNextButton":"NewsAnnouncements_prevNextButton__1co5y"};